export default [
  {
    locale: "pl",
    href: "https://natu.care/pl",
  },
  {
    locale: "x-default",
    href: "https://natu.care/pl",
  },
  {
    locale: "en-GB",
    href: "https://natu.care/uk",
  },
  {
    locale: "uk",
    href: "https://natu.care/ua",
  },
  {
    locale: "de",
    href: "https://natu.care/de",
  },
  {
    locale: "cs",
    href: "https://natu.care/cz",
  },
  {
    locale: "ro",
    href: "https://natu.care/ro",
  },
  {
    locale: "hu",
    href: "https://natu.care/hu",
  },
  {
    locale: "sk",
    href: "https://natu.care/sk",
  },
  {
    locale: "bg",
    href: "https://natu.care/bg",
  },

  {
    locale: "fr",
    href: "https://natu.care/fr",
  },
  {
    locale: 'it',
    href: 'https://natu.care/it'
  },
  {
    locale: 'es',
    href: 'https://natu.care/es'
  },

  {
    locale: 'nl',
    href: 'https://natu.care/nl'
  },
  {
    locale: 'sv',
    href: 'https://natu.care/se'
  },
  {
    locale: 'da',
    href: 'https://natu.care/dk'
  },
  {
    locale: 'fi',
    href: 'https://natu.care/fi'
  },
  {
    locale: 'pt',
    href: 'https://natu.care/pt'
  }  
];
